import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  padding-bottom: 5px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.black4};
  margin-bottom: 15px;
  position: relative;
`;

export const Title = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
  margin-left: 20px;
  padding: 0 0 20px 0;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const PercentageWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  min-width: 0;
  max-width: 600px;
  gap: 15px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    max-width: 800px;
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.lg}) {
    min-width: 516px;
    padding: 0 0 20px 0;
  }
`;

export const PercentageText = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black6};
`;

export const ProgressContainer = styled.div`
  flex: 1;
  min-width: 0;
`;
